enum SaveOption {
  JUST_THIS_ACTIVITY,
  THIS_AND_FEATURE_ACTIVITIES,
  ALL_ACTIVITIES,
}

export default SaveOption;
